module.exports = __webpack_public_path__ + "static/img-Sanitation-467251ed16e66ad243dae72f771e5b4e.jpg";